import { CONFIG_ELEMENTS } from '@vedalib/editor/lib/elements'

import { t } from 'services/Translation'

import { ElementGroup } from '../../elements.types'
import { genElementConfig } from '../../genElementConfig'
import CourseStructureDemo from './CourseStructureDemo'
import CourseStructureElement from './CourseStructureElement'
import CourseStructureFormBrand from './CourseStructureFormBrand'
import { STYLE_FORM_SCHEMA } from './CourseStructureFormStyle'
import CourseStructureFormValue from './CourseStructureFormValue'
import icon from './assets/courseStructure.svg'
import './courseStructureTypes'

export default genElementConfig(CONFIG_ELEMENTS.courseStructure, {
  icon,
  group: ElementGroup.cover,
  label: t('elements.courseStructure.label'),
  styleFields: STYLE_FORM_SCHEMA,
  Element: CourseStructureElement,
  Demo: [CourseStructureDemo],
  FormValue: CourseStructureFormValue,
  FormBrand: CourseStructureFormBrand,
  EditorActions: null,
})
